var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-avatar',{staticStyle:{"cursor":"pointer"},attrs:{"size":"25px","rounded":"0"},on:{"click":function($event){return _vm.openThumbnail()}}},[_c('v-img',{attrs:{"alt":"Avatar","src":this.imageUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }